import {
  orderTypeConstants,
  ED_ORDER_TYPE_EXPIRATION_PERIOD,
} from "constants/order";
import { centsToDollars } from "helpers/price";
import usePrice from "hooks/usePrice";
import { isEmpty } from "lodash";
import { PayNowSection } from "pages/OrderOverview/components/PayNowSection";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { onChangeAccountInfo } from "store/slices/order";
import { IOrder } from "types/Order/Order";
import { IProvider } from "types/Provider/Provider";

export default function PayMoreSection({
  order,
  onReturnClick,
  setShowPaymentSection,
  onUpdateOrder,
}: {
  order: IOrder;
  onReturnClick: () => void;
  setShowPaymentSection: (showPaymentSection: any) => void;
  onUpdateOrder?: () => void;
}) {
  const { getClearPriceByOrderType } = usePrice();
  const dispatch = useDispatch();
  useEffect(() => {
    const accountInfo = order.account;

    if (accountInfo) {
      dispatch(onChangeAccountInfo({ accountInfo }));
    }
  }, [order]);
  const getExpirationDays = () => {
    if (isEmpty(order)) return undefined;

    if (
      order.orderType === orderTypeConstants.ED ||
      order.orderType === orderTypeConstants.BARIATRICS
    ) {
      return ED_ORDER_TYPE_EXPIRATION_PERIOD;
    }

    // return (order.account.providers[0] as unknown as IProvider)
    //   .expirationDays;
    return 0;
  };
  const prices = getClearPriceByOrderType({ order });
  const totalSaving = centsToDollars(prices.totalSaving);
  const fullPrice = centsToDollars(prices.total);
  const expirationDays = getExpirationDays();
  const activePaymentPlan = order.paymentPlan?.find(
    (paymentPlan) => !!paymentPlan.active
  );
  const remainingPrice = centsToDollars(
    activePaymentPlan?.remainingAmountInCents || 0
  );
  return (
    <PayNowSection
      {...{
        expirationDays,
        orderInfo: order,
        showPaymentSection: {
          paymentPlan: false,
          paymentSection: false,
          paymentSuccess: false,
          receiptAvailable: false,
        },
        setShowPaymentSection,
        onReturnClick,
        clearPrice: remainingPrice,
        totalSaving,
        fullPrice,
        payRemainingPrice: true,
        onUpdateOrder,
      }}
    />
  );
}
